function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 15px;\n\n  h3 {\n    font-weight: 500;\n    font-size: 16px;\n    padding: 15px 0 0;\n    display: block;\n  }\n\n  p {\n    margin-bottom: 10px;\n  }\n\n  input,\n  textarea {\n    margin-top: 15px;\n  }\n\n  label,\n  .react-date-picker__wrapper {\n    margin-top: 15px;\n  }\n\n  label .react-date-picker__wrapper {\n    margin-top: 0px;\n  }\n\n  .react-date-picker__inputGroup input {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 20px;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-top: 10px;\n  font-weight: 500;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 20px 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 20px;\n\n  a {\n    margin: 15px 0 0;\n    display: inline-block;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import connectRequest from "../../../utils/connect-request";
import { requests, utils } from "../../../modules/product";
import propTypes from "prop-types";
import styled from "styled-components";
import { object, string, date } from "yup";
import { Formik, Form } from "formik";
import { withContext } from "../../wr-context";
import FormikButton from "../../button";
import { FormikDatepicker } from "../../datepicker";
import GenerateProposalDropdown from "../../generate-proposal-dropdown";
import Link from "../../link";
import { FormikInput } from "../../input";
import { FormikTextarea } from "../../textarea";
import { Grid, Row, Col } from "../../grid";
import { IoIosRefresh } from "react-icons/io";
import Progress from "../../progress";
import { MutedText, MediumText, EngravedText, CenteredText } from "../../text";
import i18n from "../../../utils/i18n";
import formatCurrency from "../../../utils/format-currency";
var Product = styled.div(_templateObject());
var ModalDescription = styled.p(_templateObject1());
var ProductDescription = styled.p(_templateObject2());
var ProductPricing = styled.p(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.primary;
});
var StyledProgress = styled(Progress)(_templateObject4());
var Products = styled.div(_templateObject5());
var validationSchema = object({
    name: string().required("Name is a required field"),
    company: string().required("Company is a required field"),
    email: string().email().required("Email is a required field"),
    desiredStartDate: date(),
    notes: string()
});
var _BuildQuote = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(_BuildQuote, Component);
    var _super = _createSuper(_BuildQuote);
    function _BuildQuote(props) {
        _classCallCheck(this, _BuildQuote);
        var _this;
        _this = _super.call(this, props);
        _this.asDraft = false;
        _this.asQuotePdf = false;
        _this.asQuoteWord = false;
        _this.contextUpdated = false;
        _this.setSubmitType = function(submitType) {
            _this.asDraft = false;
            _this.asQuotePdf = false;
            _this.asQuoteWord = false;
            if (submitType === "asDraft") {
                _this.asDraft = true;
            }
            if (submitType === "asQuotePdf") {
                _this.asQuotePdf = true;
            }
            if (submitType === "asQuoteWord") {
                _this.asQuoteWord = true;
            }
        };
        _this.handleSubmit = function(values, param) {
            var setSubmitting = param.setSubmitting;
            if (_this.asQuotePdf) {
                var _props, ref;
                (ref = (_props = _this.props).submitProposal) === null || ref === void 0 ? void 0 : ref.call(_props, {
                    asQuotePdf: _this.asQuotePdf,
                    formValues: values,
                    fromDecisionTree: true
                });
                _this.props.context.actions.openModal({
                    showClose: false,
                    body: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ModalDescription, null, "We are generating your proposal"), /*#__PURE__*/ React.createElement(Progress, null))
                });
            }
            if (_this.asQuoteWord) {
                var _props1, ref1;
                (ref1 = (_props1 = _this.props).submitProposal) === null || ref1 === void 0 ? void 0 : ref1.call(_props1, {
                    asQuoteWord: _this.asQuoteWord,
                    formValues: values,
                    fromDecisionTree: true
                });
                _this.props.context.actions.openModal({
                    showClose: false,
                    body: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ModalDescription, null, "We are generating your proposal"), /*#__PURE__*/ React.createElement(Progress, null))
                });
            }
            setSubmitting(false);
        };
        _this.updateCart = function(product) {
            var priceRow = product.rows.find(function(row) {
                return row.rowType === "component:pricing";
            });
            var priceRowControl = (priceRow === null || priceRow === void 0 ? void 0 : priceRow.control) && typeof (priceRow === null || priceRow === void 0 ? void 0 : priceRow.control) === "string" ? JSON.parse(priceRow === null || priceRow === void 0 ? void 0 : priceRow.control) : priceRow === null || priceRow === void 0 ? void 0 : priceRow.control;
            var price = priceRowControl && priceRowControl.constants ? priceRowControl.constants.find(function(c) {
                return c.name === "cost";
            }) : null;
            product.price = price ? price.value / 100 : product.service_rate_cents ? product.service_rate_cents : 0;
            if (!_this.contextUpdated) {
                _this.props.context.actions.addProductToDecisionTreeCart(product);
                _this.contextUpdated = true;
            }
        };
        return _this;
    }
    var _proto = _BuildQuote.prototype;
    _proto.render = function render() {
        var ref;
        var _props = this.props, Body = _props.Body, Footer = _props.Footer, DecisionTreeBody = _props.DecisionTreeBody, DecisionTreeFooter = _props.DecisionTreeFooter, question = _props.question, animateContent = _props.animateContent, fetchProduct = _props.fetchProduct, asDoc = _props.asDoc, asPdf = _props.asPdf, showVMSButton = _props.showVMSButton, initialValues = _props.initialValues, valuesTypes = _props.valuesTypes, validationSchema = _props.validationSchema;
        var isProduct = question.type === "product";
        var isProducts = question.type === "products";
        var products = question.products || [];
        var bundles = question.bundles || [];
        var childValue = question.childValue || [];
        if (isProducts && (products.length > 0 || bundles.length > 0)) {
            return /*#__PURE__*/ React.createElement(Products, null, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                xs: 12
            }, /*#__PURE__*/ React.createElement("p", null, "We have found a few products that will suit you:"))), /*#__PURE__*/ React.createElement(Row, null, childValue.map(function(product, index) {
                if (product.type === "product") {
                    var productName = products.find(function(p) {
                        return p.id === product.id;
                    });
                    return /*#__PURE__*/ React.createElement(Col, {
                        "data-testid": "d3-build-quote-".concat(product.id),
                        xs: 12,
                        key: product.id || index
                    }, /*#__PURE__*/ React.createElement(Link, {
                        to: "/product/".concat(product.id),
                        target: "_blank"
                    }, productName === null || productName === void 0 ? void 0 : productName.name));
                }
                if (product.type === "bundle") {
                    var bundleName = bundles.find(function(p) {
                        return p.id === product.id;
                    });
                    return /*#__PURE__*/ React.createElement(Col, {
                        "data-testid": "d3-build-quote-".concat(product.id),
                        xs: 12,
                        key: product.id || index
                    }, /*#__PURE__*/ React.createElement(Link, {
                        to: "/bundle/".concat(product.id),
                        target: "_blank"
                    }, bundleName === null || bundleName === void 0 ? void 0 : bundleName.name));
                }
            }))));
        }
        var product = null;
        var pricing = null;
        if (isProduct && fetchProduct.pending) {
            return /*#__PURE__*/ React.createElement(StyledProgress, null);
        } else if (isProduct && fetchProduct.rejected) {
            return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MutedText, null, i18n("decisionTree.quoteBuilder.errors.buildQuote"))))));
        }
        if (isProduct && fetchProduct.fulfilled) {
            product = fetchProduct.value;
            var pricingRow = product === null || product === void 0 ? void 0 : product.rows.find(function(row) {
                return row.rowType === "component:pricing";
            });
            var pricingValue = {
                schedule: {
                    serviceRateLabel: formatCurrency(utils.getPrice(product))
                }
            };
            pricing = pricingRow && pricingRow.control ? typeof pricingRow.control === "string" ? JSON.parse(pricingRow.control) : pricingRow.control : pricingValue;
            this.updateCart(product);
        }
        return /*#__PURE__*/ React.createElement(Formik, {
            onSubmit: this.handleSubmit,
            initialValues: initialValues,
            validationSchema: validationSchema
        }, /*#__PURE__*/ React.createElement(Form, {
            noValidate: true
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Body, null, /*#__PURE__*/ React.createElement(DecisionTreeBody, {
            className: animateContent ? "toggleAnimation" : ""
        }, isProduct && product && /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Product, null, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
            xs: 12
        }, /*#__PURE__*/ React.createElement("p", null, i18n("decisionTree.quoteBuilder.form.description")))), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
            xs: 6
        }, /*#__PURE__*/ React.createElement("h3", null, i18n("decisionTree.quoteBuilder.form.theBasics")), Object.keys(initialValues).map(function(key, i) {
            if (valuesTypes[key] === "datepicker") {
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h3", null, i18n("proposalGeneration.form.desiredStartDate")), /*#__PURE__*/ React.createElement(FormikDatepicker, {
                    fullWidth: true,
                    large: true,
                    name: "desiredStartDate"
                }));
            }
            return /*#__PURE__*/ React.createElement(FormikInput, {
                fullWidth: true,
                large: true,
                name: key,
                type: valuesTypes[key],
                placeholder: i18n("proposalGeneration.form.".concat(key))
            });
        }), /*#__PURE__*/ React.createElement("h3", null, i18n("decisionTree.quoteBuilder.form.anythingElse")), /*#__PURE__*/ React.createElement(FormikTextarea, {
            noResize: true,
            fullWidth: true,
            large: true,
            name: "notes",
            placeholder: i18n("decisionTree.quoteBuilder.form.addHere")
        })), /*#__PURE__*/ React.createElement(Col, {
            xsOffset: 1,
            xs: 5
        }, /*#__PURE__*/ React.createElement("h3", null, product.name), /*#__PURE__*/ React.createElement(ProductDescription, null, product.description), /*#__PURE__*/ React.createElement(ProductPricing, null, pricing === null || pricing === void 0 ? void 0 : (ref = pricing.schedule) === null || ref === void 0 ? void 0 : ref.serviceRateLabel))))), question.type === "message" && "Waiting for more items to be added!")), /*#__PURE__*/ React.createElement(Footer, {
            className: "decision-tree-footer"
        }, /*#__PURE__*/ React.createElement(DecisionTreeFooter, null, /*#__PURE__*/ React.createElement(FormikButton, {
            fullWidth: true,
            primary: true,
            type: "button",
            onClick: this.props.resetDecisionTree,
            className: "start-over"
        }, /*#__PURE__*/ React.createElement(IoIosRefresh, {
            size: 20
        }), i18n("decisionTree.quoteBuilder.startOver")), /*#__PURE__*/ React.createElement(GenerateProposalDropdown, {
            theme: this.props.context.theme.components.dropdown.color,
            options: {
                asPdf: asPdf,
                asDoc: asDoc,
                asDraft: false
            },
            onChange: this.setSubmitType
        }), showVMSButton && /*#__PURE__*/ React.createElement(FormikButton, {
            className: "send-to-vms",
            fullWidth: true,
            primary: true,
            type: "button",
            disabled: true
        }, i18n("proposalGeneration.sendToVms")))))));
    };
    return _BuildQuote;
}(Component);
_BuildQuote.propTypes = {
    initialValues: propTypes.object,
    validationSchema: propTypes.object,
    valuesTypes: propTypes.object,
    showVMSButton: propTypes.bool
};
_BuildQuote.defaultProps = {
    initialValues: {
        name: "",
        company: "",
        email: "",
        desiredStartDate: "",
        notes: ""
    },
    validationSchema: validationSchema,
    valuesTypes: {
        name: "text",
        company: "text",
        email: "email",
        desiredStartDate: "datepicker"
    },
    showVMSButton: false
};
var BuildQuote = connectRequest(function(props) {
    var ref;
    var isProduct = props.question.type === "product" && props.question.productId;
    return {
        fetchProduct: isProduct ? requests.fetchProductById((ref = props.question) === null || ref === void 0 ? void 0 : ref.productId) : {
            value: {
                pending: false,
                rejected: true
            }
        }
    };
})(withContext(_BuildQuote));
export default BuildQuote;
